"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconTeamChat = /*#__PURE__*/
function (_Icon) {
  _inherits(IconTeamChat, _Icon);
  function IconTeamChat(props) {
    var _this;
    _classCallCheck(this, IconTeamChat);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconTeamChat).call(this, props));
    _this.name = 'IconTeamChat';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "team-chat_svg__group0"
    }, _react2.default.createElement("path", {
      className: "team-chat_svg__path0",
      d: "M13.5 17a.5.5 0 010-1H21a.5.5 0 010 1h-7.5z"
    }), _react2.default.createElement("path", {
      className: "team-chat_svg__path1",
      d: "M13.5 19a.5.5 0 010-1h5a.5.5 0 010 1h-5z"
    }), _react2.default.createElement("path", {
      className: "team-chat_svg__path2",
      d: "M14.5 13a.499.499 0 01-.5-.481 4.804 4.804 0 011.282-3.471A4.811 4.811 0 0119.02 7.5 4.806 4.806 0 0124 12.519a.498.498 0 01-.5.48h-9zm8.489-1a3.822 3.822 0 00-3.97-3.5 7.018 7.018 0 00-.336 0 3.812 3.812 0 00-2.666 1.228 3.823 3.823 0 00-1.006 2.273h7.978z"
    }), _react2.default.createElement("path", {
      className: "team-chat_svg__path3",
      d: "M19 7c-1.93 0-3.5-1.57-3.5-3.5S17.07 0 19 0a3.515 3.515 0 013.5 3.5C22.5 5.43 20.93 7 19 7zm-2.172-4.733A2.454 2.454 0 0016.5 3.5C16.5 4.879 17.621 6 19 6c1.27 0 2.321-.951 2.479-2.178A4.09 4.09 0 0120.286 4h-.03a4.284 4.284 0 01-3.428-1.733zm.683-.77A3.251 3.251 0 0020.249 3l.026.25-.001-.25c.38 0 .762-.073 1.122-.211A2.51 2.51 0 0019 1c-.537 0-1.058.175-1.489.497z"
    }), _react2.default.createElement("path", {
      className: "team-chat_svg__path4",
      d: "M.5 24a.499.499 0 01-.5-.481A4.841 4.841 0 015.02 18.5a4.795 4.795 0 013.432 1.282A4.803 4.803 0 0110 23.52a.5.5 0 01-.5.48h-9zm8.489-1a3.834 3.834 0 00-3.829-3.503l-.141.002a7.016 7.016 0 00-.336 0 3.84 3.84 0 00-3.672 3.5h7.978z"
    }), _react2.default.createElement("path", {
      className: "team-chat_svg__path5",
      d: "M5 18c-1.93 0-3.5-1.57-3.5-3.5a3.48 3.48 0 011.026-2.474l.026-.024A3.472 3.472 0 015 11a3.51 3.51 0 013.5 3.5C8.5 16.43 6.93 18 5 18zm-2.16-4.756c-.223.381-.34.809-.34 1.256C2.5 15.878 3.621 17 5 17a2.503 2.503 0 002.478-2.17c-.381.113-.77.17-1.161.17h-.042a4.273 4.273 0 01-3.435-1.756zm.69-.762A3.25 3.25 0 006.278 14h.037a3.13 3.13 0 001.085-.2A2.51 2.51 0 005 12c-.529 0-1.043.17-1.47.482z"
    }), _react2.default.createElement("path", {
      className: "team-chat_svg__path6",
      d: "M14 24a.503.503 0 01-.5-.5V22h-1c-.827 0-1.5-.673-1.5-1.5v-5c0-.827.673-1.5 1.5-1.5h10c.827 0 1.5.673 1.5 1.5v5c0 .827-.673 1.5-1.5 1.5h-5.825l-2.363 1.891A.504.504 0 0114 24zm-1.5-9a.5.5 0 00-.5.5v5a.5.5 0 00.5.5H14a.5.5 0 01.5.5v.959l1.688-1.35A.504.504 0 0116.5 21h6a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5h-10z"
    }), _react2.default.createElement("path", {
      className: "team-chat_svg__path7",
      d: "M2.5 3a.5.5 0 010-1H10a.5.5 0 010 1H2.5z"
    }), _react2.default.createElement("path", {
      className: "team-chat_svg__path8",
      d: "M2.5 5a.5.5 0 010-1h5a.5.5 0 010 1h-5z"
    }), _react2.default.createElement("path", {
      className: "team-chat_svg__path9",
      d: "M10 10.5a.5.5 0 01-.354-.146L7.293 8H1.5C.673 8 0 7.327 0 6.5v-5C0 .673.673 0 1.5 0h10c.827 0 1.5.673 1.5 1.5v5c0 .827-.673 1.5-1.5 1.5h-1v2a.498.498 0 01-.5.5zM1.5 1a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h6a.5.5 0 01.354.146L9.5 8.793V7.5A.5.5 0 0110 7h1.5a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5h-10z"
    })));
    return _this;
  }
  return IconTeamChat;
}(_Icon3.default);
exports.default = IconTeamChat;